module.exports = __webpack_public_path__ + "img/search_files.195271a1.svg";